import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import styles from "./sk-CardBodyHeader.module.css";
export const CardBodyHeader = ({ className, children, ...restProps }) => {
    const mainClassNames = clsx(className, styles.main);
    return (_jsx("header", { ...restProps, className: clsx(mainClassNames), children: children }));
};
CardBodyHeader.displayName = "CardBodyHeader";
//# sourceMappingURL=CardBodyHeader.js.map